export interface ExoneracionesMod {
    idcontrol: number;
    catEdicionesId: number;
    transacciones: number;
    userAlumnoId : string;
    solicitado_por: string;    
    aprobado_por: string;
    fecha_de_solicitud: any;
    fecha_de_aprobacion: any;
    estado : number;
    comentario: string;
    razon_de_solicitud: string;
    porcentaje_de_solicitud: number;    
    nombreCompletoAprobadopor: string; 
   
}

export class ExoneracionesMod implements ExoneracionesMod {
   
    constructor(init?: ExoneracionesModFormValues) {
        Object.assign(this, init);
    }
}

export class ExoneracionesModFormValues {
    idcontrol: number = 0
    catEdicionesId: number = 0;
    transacciones: number = 0;
    userAlumnoId: string = "";
    solicitado_por: string = "";
    aprobado_por: string = "";
    fecha_de_solicitud: Date | null = null;
    fecha_de_aprobacion: Date | null = null;
    estado: number = 0;
    comentario: string = "";
    razon_de_solicitud: string = "";
    porcentaje_de_solicitud: number = 0;
    nombreCompletoAprobadopor: string = "";
   
    
    constructor(ExoneracionesMod?: ExoneracionesModFormValues) {
        if (ExoneracionesMod) {
            this.idcontrol = ExoneracionesMod.idcontrol;          
            this.catEdicionesId = ExoneracionesMod.catEdicionesId;
            this.transacciones = ExoneracionesMod.transacciones;
            this.userAlumnoId = ExoneracionesMod.userAlumnoId;
            this.solicitado_por = ExoneracionesMod.solicitado_por;
            this.aprobado_por = ExoneracionesMod.aprobado_por;
            this.fecha_de_solicitud = ExoneracionesMod.fecha_de_solicitud;
            this.fecha_de_aprobacion = ExoneracionesMod.fecha_de_aprobacion;                      
            this.estado = ExoneracionesMod.estado;
            this.comentario = ExoneracionesMod.comentario;
            this.razon_de_solicitud = ExoneracionesMod.razon_de_solicitud
            this.porcentaje_de_solicitud = ExoneracionesMod.porcentaje_de_solicitud; 
            this.nombreCompletoAprobadopor = ExoneracionesMod.nombreCompletoAprobadopor;          
                     
        }
    }
}


export interface ExoneracionesList {
    idcontrol: number;
    catCurso: string;
    catEdicionesId: number;
    transacciones: string;
    alumno : string;
    dpi: string;
    solicitado_por: string;    
    aprobado_por: string;
    fecha_de_solicitud: any;
    fecha_de_aprobacion: any;
    estado : string;
    comentario: string;
    razon_de_solicitud: string;
    porcentaje_de_solicitud: number;   
    nombreCompletoAprobadopor: string;   
   
}

export class ExoneracionesList implements ExoneracionesList {
   
    constructor(init?: ExoneracionesListFormValues) {
        Object.assign(this, init);
    }
}

export class ExoneracionesListFormValues {
    idcontrol: number = 0
    catCurso: string = "";
    catEdicionesId: number = 0;
    transacciones: string = "";
    alumno: string = "";
    dpi: string = "";
    solicitado_por: string = "";
    aprobado_por: string = "";
    fecha_de_solicitud: Date | null = null;
    fecha_de_aprobacion: Date | null = null;
    estado: string = "";
    comentario: string = "";
    razon_de_solicitud: string = "";
    porcentaje_de_solicitud: number = 0;
    nombreCompletoAprobadopor: string = ""; 
   
    
    constructor(ExoneracionesList?: ExoneracionesListFormValues) {
        if (ExoneracionesList) {
            this.idcontrol = ExoneracionesList.idcontrol;
            this.catCurso = ExoneracionesList.catCurso;
            this.catEdicionesId = ExoneracionesList.catEdicionesId;
            this.transacciones = ExoneracionesList.transacciones;
            this.alumno = ExoneracionesList.alumno;
            this.dpi = ExoneracionesList.dpi;
            this.solicitado_por = ExoneracionesList.solicitado_por;
            this.aprobado_por = ExoneracionesList.aprobado_por;
            this.fecha_de_solicitud = ExoneracionesList.fecha_de_solicitud;
            this.fecha_de_aprobacion = ExoneracionesList.fecha_de_aprobacion;                      
            this.estado = ExoneracionesList.estado;
            this.comentario = ExoneracionesList.comentario;
            this.razon_de_solicitud = ExoneracionesList.razon_de_solicitud
            this.porcentaje_de_solicitud = ExoneracionesList.porcentaje_de_solicitud;  
            this.nombreCompletoAprobadopor = ExoneracionesList.nombreCompletoAprobadopor;          
                     
        }
    }
}



export interface ExoneracionesDetail {
    idcontrol: number;
    codigoCurso: number;
    nombreCurso : string;
    operaciones: number;
    operacionesDetalle: string;
    alumno : string;
    appUserIdAlumno: string;
    appUserIdAprobadoPor: string;
    solicitadoPor: string;
    appUserIdSolicitadoPor: string;    
    aprobadoPor: string;
    fecha_de_solicitud: any;
    fecha_de_aprobacion: any;
    estado : number;
    tipoEstado: string;
    comentario: string;
    razon_de_solicitud: string;
    porcentaje_de_solicitud: number;     
   
}

export class ExoneracionesDetail implements ExoneracionesDetail {
   
    constructor(init?: ExoneracionesDetailFormValues) {
        Object.assign(this, init);
    }
}

export class ExoneracionesDetailFormValues {
    idcontrol: number = 0
    codigoCurso: number = 0;
    nombreCurso: string = ""
    operaciones: number = 0;
    operacionesDetalle: string = "";
    alumno: string = "";
    appUserIdAlumno: string = "";
    appUserIdAprobadoPor: string =""
    solicitadoPor: string = "";
    appUserIdSolicitadoPor: string ="";
    aprobadoPor: string = "";
    fecha_de_solicitud: Date | null = null;
    fecha_de_aprobacion: Date | null = null;
    estado: number = 0;
    tipoEstado: string = "";
    comentario: string = "";
    razon_de_solicitud: string = "";
    porcentaje_de_solicitud: number = 0;
   
    
    constructor(ExoneracionesDetail?: ExoneracionesDetailFormValues) {
        if (ExoneracionesDetail) {
            this.idcontrol = ExoneracionesDetail.idcontrol;
            this.codigoCurso = ExoneracionesDetail.codigoCurso;
            this.nombreCurso = ExoneracionesDetail.nombreCurso
            this.operaciones = ExoneracionesDetail.operaciones;
            this.operacionesDetalle = ExoneracionesDetail.operacionesDetalle;
            this.alumno = ExoneracionesDetail.alumno;
            this.appUserIdAlumno = ExoneracionesDetail.appUserIdAlumno;
            this.appUserIdAprobadoPor = ExoneracionesDetail.appUserIdAprobadoPor;
            this.solicitadoPor = ExoneracionesDetail.solicitadoPor;
            this.appUserIdSolicitadoPor = ExoneracionesDetail.appUserIdSolicitadoPor;
            this.aprobadoPor = ExoneracionesDetail.aprobadoPor;                      
            this.fecha_de_solicitud = ExoneracionesDetail.fecha_de_solicitud;
            this.fecha_de_aprobacion = ExoneracionesDetail.fecha_de_aprobacion;
            this.razon_de_solicitud = ExoneracionesDetail.razon_de_solicitud
            this.estado= ExoneracionesDetail.estado;
            this.tipoEstado = ExoneracionesDetail.tipoEstado;
            this.comentario = ExoneracionesDetail.comentario;
            this.porcentaje_de_solicitud = ExoneracionesDetail.porcentaje_de_solicitud;
                       
                     
        }
    }
}

